/**
 * 点击表格的行，跳转到拼接的url
 * 可选择跳转地址的传递参数
 * 传递的参数在本地存储空间内 键值为pageQuery
 */
import $ from "jquery"
export default {
  methods: {
    selectQueryClickJumpToSpecialUrl() {
      console.log('执行选择参数跳走的插件')
      if (!this.isBigScreenPreview() || !this.options.linkUrlVal) return
      // 先找出fid在数组中的下标
      const index = Number(this.options.trQueryValue)
      let trQueryIndex = index
      if(this.options.filedMappingList && this.options.filedMappingList.length > 0){
        for(let m=0;m<this.options.filedMappingList.length;m++){
          if(this.options.filedMappingList[m].value == index){
            trQueryIndex = m
          }
        }
      }

      // 给表格每行绑定点击事件
      setImmediate(() => {
        const domStr = this.$event.getIdsByStrId(this.myid)
        const dom = $(`.${domStr} .tableComponent .item`)
        dom.each(i => {
          const items = $(dom[i]).find("li")
          items.each(j => {
            items[j].addEventListener("click", event => {
              if (this.options.openBlankPage) {
                window.open(this.options.linkUrlVal)
              } else {
                window.location.href = this.options.linkUrlVal
              }
              window.localStorage.setItem("pageQuery", this.options.listData[j][trQueryIndex])
            })
          })
        })
      })
    }
  }
}
